// Feature flags for in-progress functionality.
//
// Pattern: env-var-driven, default OFF in production. Each flag is
// NEXT_PUBLIC_FEATURE_<NAME> = 'true' to enable. Anything else (unset,
// 'false', 'no', '0') keeps the feature dark.
//
// Why this pattern:
//   • Prod stays clean automatically. Vercel's production env doesn't
//     set these → builds with flags off. We can flip ONE env var and
//     redeploy to launch, without code surgery.
//   • Local dev runs with .env.local containing
//     `NEXT_PUBLIC_FEATURE_INTRO=true` etc, so you see the WIP
//     features while iterating.
//   • Reads are static at build time (Next.js replaces NEXT_PUBLIC_*
//     references at compile), so dead branches are tree-shaken out.
//     No runtime cost in prod for the disabled paths.
//
// To launch a feature:
//   1. Test thoroughly locally (with the flag on)
//   2. Set NEXT_PUBLIC_FEATURE_<NAME>=true on Vercel
//   3. Redeploy
//   4. (Optional) once stable, remove the flag check from the code

function bool(envValue) {
  return envValue === 'true'
}

export const FEATURES = {
  // First-visit cinematic intro (PS1-style Victor dialogue). When OFF,
  // every visitor lands straight on the world with HUDs visible. Brain
  // icon → info modal continues to work either way.
  // ART-EVENT WEEK: hard-disabled regardless of env, so no deploy or stray
  // .env can show the intro at the installation. To bring it back, restore:
  //   intro: bool(process.env.NEXT_PUBLIC_FEATURE_INTRO),
  intro: false,

  // Sacrifice / shrine system. When OFF:
  //   • /shrine page renders a "coming soon" placeholder
  //   • 3D world hides any SACRIFICE entities (no boxes around shrine)
  //   • Sim-server's POST /api/sacrifice still accepts submissions,
  //     but no UI path reaches it (and rate-limits cap any direct hits)
  shrine: bool(process.env.NEXT_PUBLIC_FEATURE_SHRINE),

  // The recognition boxes that tracked objects as you walked. Genuinely nice
  // tech, and a good demo, but they read as surveillance-cam overlay: they
  // frame the world as a feed being analysed instead of a place you're in,
  // which is the opposite of what the cosy rework is for. Off by default,
  // code kept intact. Set NEXT_PUBLIC_FEATURE_DETECTION=true to see them
  // again (the scanner and the DOM overlay both honour this).
  detection: bool(process.env.NEXT_PUBLIC_FEATURE_DETECTION),

  // Saying hello: the marks strip that opens near him in first person, the
  // E whistle, the marks that land in the world, and his spoken answer back.
  // Pulled from production 2026-08-11 to go back in later, so the code is
  // untouched and this is the only thing holding it. Set
  // NEXT_PUBLIC_FEATURE_SIGNALS=true to bring it back.
  //
  // Gated in five places, because the strip is only the visible half:
  // SignalBar and BirdReply (page), SignalMarks (the 3D world), and both
  // the key handler and the proximity opener in FirstPersonController. A
  // flag on the strip alone would have left E still whistling at him.
  signals: bool(process.env.NEXT_PUBLIC_FEATURE_SIGNALS),
}

// Auth (Privy) is optional by design: a dark deploy runs with zero auth env,
// and layout mounts the provider only when the app id exists. The UI that
// calls usePrivy has to make the same bargain, or a keyless local run
// crashes the whole page the moment a drawer mounts.
export const HAS_AUTH = !!process.env.NEXT_PUBLIC_PRIVY_APP_ID
